"use strict";

const LogoutCtrl = ['$state', 'AuthService', 'Notification',
function($state, AuthService, Notification) {
    var ctrl = this;

    ctrl.logout = function(){
      AuthService.logout().then(
        function(){
          Notification.success('Sie wurden erfolgreich abgemeldet.');
          $state.go('main.home');
        },
        function(){}
      );
    };
  }];

module.exports = {
  template: '<a ng-click="$ctrl.logout()" title="Abmelden"><i class="fa fa-power-off"></i></a>',
  controller: LogoutCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/logout.js